module.exports = __webpack_public_path__ + "static/media/industriel-1.41e32465.jpg";